/* -------------------------------------------------------------------------- */
/*                                    页面权限                                 */
/* -------------------------------------------------------------------------- */

// 组织架构
export const ORGANIZATION_PAGE = 'e0aa559c-5915-4b54-9b80-d79bd2cb0619'

/* -------------------------------------------------------------------------- */
/*                                    操作权限                                 */
/* -------------------------------------------------------------------------- */

// 管理部门
export const DEPT_ACTION_UUID = 'c9d4c507-c93e-481a-9d78-04d2ec4c22e8'

// 管理用户
export const USER_ACTION_UUID = '021c87a4-b9d0-4dfa-ad9e-1343aee56cef'
